let workerP = null;

const getWorker = () => {
  if (!workerP) {
    workerP = import("tesseract.js").then(async ({ createWorker }) => {
      const w = await createWorker("eng");
      await w.setParameters({ tessedit_char_whitelist: "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789", tessedit_pageseg_mode: "7" });
      return w;
    }).catch((e) => { workerP = null; throw e; });
  }
  return workerP;
};

export const pickPlate = (text) => {
  const s = String(text || "").toUpperCase().replace(/[^A-Z0-9\n ]/g, "");
  const flat = s.replace(/\s+/g, "");
  const it = flat.match(/[A-Z]{2}\d{3}[A-Z]{2}/);
  if (it) return it[0];
  const toks = s.split(/\s+/).filter((t) => t.length >= 5 && t.length <= 8 && /[A-Z]/.test(t) && /\d/.test(t));
  return toks.sort((a, b) => b.length - a.length)[0] || "";
};

export const readPlateOnDevice = async (canvas) => {
  const w = await getWorker();
  const { data } = await w.recognize(canvas);
  return pickPlate(data?.text);
};

export const grabFrame = (video, crop) => {
  const vw = video.videoWidth, vh = video.videoHeight;
  const sx = crop ? vw * 0.08 : 0, sy = crop ? vh * 0.34 : 0;
  const sw = crop ? vw * 0.84 : vw, sh = crop ? vh * 0.32 : vh;
  const scale = crop ? Math.max(1, 1200 / sw) : Math.min(1, 1280 / sw);
  const c = document.createElement("canvas");
  c.width = Math.round(sw * scale); c.height = Math.round(sh * scale);
  const ctx = c.getContext("2d");
  if (crop) ctx.filter = "grayscale(1) contrast(1.6)";
  ctx.drawImage(video, sx, sy, sw, sh, 0, 0, c.width, c.height);
  return c;
};
